(function () {
  'use strict';

  /* Directives */
  angular.module('wsLrs.directives').directive('wsJsonEditor', function wsJsonEditor() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function link(scope, element, attr, ngModel) {
        function into(input) {
          //Suppress any database information from displaying
          return angular.fromJson(input);
        }
        function out(data) {
          delete data.id;
          delete data.updated;
          delete data.created;
          delete data.version;
          return angular.toJson(data, true);
        }
        ngModel.$parsers.push(into);
        ngModel.$formatters.push(out);
      }
    };
  });
})();
